import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import { Axios } from "../config";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "../Style/Subscribe.css";

function Unsubscribe() {
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    if (!phone || !isValidPhoneNumber(phone)) {
      setStatus("invalid");
      setLoading(false);
      return;
    }

    try {
      await Axios.post("/whatsapp/unsubscribe", { phone });
      setStatus("success");
      setPhone("");
    } catch (err) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="subscribe-page">
        <div className="subscribe-card">
          <div className="subscribe-icon" style={{ color: "#ff6b6b" }}>
            <i className="fas fa-bell-slash"></i>
          </div>

          <h1>Unsubscribe</h1>

          <p className="subscribe-subtitle">
            Enter your WhatsApp number to stop receiving Shaheen Cricket Club game reminders.
          </p>

          <form className="subscribe-form" onSubmit={handleSubmit}>
            <div className="subscribe-field">
              <label>WhatsApp Number</label>
              <PhoneInput
                international
                defaultCountry="CA"
                value={phone}
                onChange={setPhone}
                countryCallingCodeEditable={false}
                className="phone-input"
              />
              <span className="subscribe-hint">
                Enter the same number you subscribed with
              </span>
            </div>

            {status === "invalid" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Please enter a valid WhatsApp number
              </div>
            )}

            {status === "error" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Something went wrong. Try again.
              </div>
            )}

            {status === "success" && (
              <div className="subscribe-message success">
                <i className="fas fa-check-circle"></i>
                You've been unsubscribed successfully.
              </div>
            )}

            <button
              type="submit"
              className="subscribe-btn"
              disabled={loading}
              style={{ background: "#c0392b" }}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Unsubscribing...
                </>
              ) : (
                <>
                  <i className="fas fa-bell-slash"></i> Unsubscribe
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Unsubscribe;
